import { ADD_NEW_FAMILY, ADD_NEW_FAMILY_ERROR, ADD_NEW_FAMILY_SUCCESS, FAMILY_TREE, FAMILY_TREE_ERROR, FAMILY_TREE_SUCCESS, GET_COUNTRIES, GET_COUNTRIES_ERROR, GET_COUNTRIES_SUCCESS, PATIENT_DETAILS, PATIENT_DETAILS_ERROR, PATIENT_DETAILS_SUCCESS, DELETE_FAMILY_MEMBER, DELETE_FAMILY_MEMBER_SUCCESS, DELETE_FAMILY_MEMBER_ERROR, UPDATE_FAMILY_MEMBER, UPDATE_FAMILY_MEMBER_SUCCESS, UPDATE_FAMILY_MEMBER_ERROR } from './Constant';
import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

// userReducer.js
const initialState = {
    user: null,
    loading: false,
    error: null,
    patientDetails: null,
    familyTreeDetails: null,
    countryDetails: null,
    successMessage: null,
};
  
export const familyTreeReducer = (state = initialState, action) => {
    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    switch (action.type) {
    case PATIENT_DETAILS:
        return { ...state, loading: true, successMessage: null };
    case PATIENT_DETAILS_SUCCESS :        
        return { ...state, patientDetails : action.payload, loading: false };
    case PATIENT_DETAILS_ERROR :
        return { ...state,loading: false };
    case FAMILY_TREE :
        return { ...state, loading: true };
    case FAMILY_TREE_SUCCESS :              
        return { ...state, familyTreeDetails : action.payload, loading: false };
    case FAMILY_TREE_ERROR :
        return { ...state,loading: false };
    case GET_COUNTRIES :
        return { ...state, loading: true, successMessage : null };
    case GET_COUNTRIES_SUCCESS :              
        return { ...state, countryDetails : action.payload, loading: false };
    case GET_COUNTRIES_ERROR :
        return { ...state,loading: false };
    case ADD_NEW_FAMILY :
        return { ...state, loading: true, successMessage: null };
    case ADD_NEW_FAMILY_SUCCESS :              
        return { 
            ...state, 
            successMessage : langdata.PatientRegistrationSuccess,
            loading: false 
        };
    case ADD_NEW_FAMILY_ERROR :
        return { ...state,loading: false };
    case DELETE_FAMILY_MEMBER:
        return {
            ...state,
            loading: true,
            error: null,
        };
    case DELETE_FAMILY_MEMBER_SUCCESS:
        return {
            ...state,
            loading: false,
            error: null,
        };
    case DELETE_FAMILY_MEMBER_ERROR:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    case UPDATE_FAMILY_MEMBER:
        return {
            ...state,
            loading: true,
            error: null,
            successMessage: null,
        };
    case UPDATE_FAMILY_MEMBER_SUCCESS:
        return {
            ...state,
            loading: false,
            successMessage: langdata.FamilyMemberUpdateSuccess,
        };
    case UPDATE_FAMILY_MEMBER_ERROR:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    default:
        return state;
    }
};